import LocalizedStrings from 'localized-strings';

import { PaymentCardType } from 'types/creditCard';

const locales = new LocalizedStrings({
  en: {
    badge: 'Instant',
    description:
      'All our cards are Mastercard Business compatible with Apple Pay and Google Pay.',
    next: 'Next',
    options: {
      [PaymentCardType.VIRTUAL]: {
        budget: {
          description:
            'Perfect for one-time expenses, this temporary virtual card deactivates once the defined budget is reached.',
          title: 'Budget card',
        },
        default: {
          description:
            'Perfect for paying for your online purchases and subscriptions or paying in-store with your phone via Apple Pay or Google Pay.',
          title: 'Virtual card',
        },
      },
      [PaymentCardType.PHYSICAL]: {
        description: 'Perfect for everyday purchases and cash withdrawals.',
        title: 'Physical card',
      },
    },
    prices: {
      forbidden: 'Card already requested or activated',
      free: 'Free',
    },
    request: 'Request card',
    sidebar: {
      description:
        'Your account admin has to approve your request for the card to be ordered. You will be informed about each step of the process.',
      title: 'Your request will need approval',
    },
    title: 'Choose a card type',
  },
  fr: {
    badge: 'Instantanée',
    description:
      'Toutes nos cartes sont des Mastercard Business compatibles avec Apple Pay et Google Pay.',
    next: 'Suivant',
    options: {
      [PaymentCardType.VIRTUAL]: {
        budget: {
          description:
            'Idéale pour les dépenses ponctuelles, cette carte virtuelle temporaire se désactive une fois le budget défini atteint.',
          title: 'Carte virtuelle à budget',
        },
        default: {
          description:
            'Idéale pour payer vos achats et abonnements en ligne ou payer en magasin avec votre téléphone via Apple Pay ou Google Pay.',
          title: 'Carte virtuelle',
        },
      },
      [PaymentCardType.PHYSICAL]: {
        description:
          'Idéale pour les achats du quotidien et les retraits d’espèces.',
        title: 'Carte physique',
      },
    },
    prices: {
      forbidden: 'Carte déjà demandée ou activée',
      free: 'Gratuite',
    },
    request: 'Envoyer la demande',
    sidebar: {
      description:
        'Un administrateur du compte devra approuver votre demande pour que la carte soit commandée. Vous serez notifié·e à chaque étape du processus.',
      title: 'Votre demande devra être approuvée',
    },
    title: 'Choisissez un type de carte',
  },
} as const);

export default locales;
